module.exports = __webpack_public_path__ + "static/media/art70.50b2044b.jpg";